export const INSURANCE_SECTIONS = {
  'defined': 'С объявленной и подтверждённой стоимостью',
  'defined_after': 'С объявленной стоимостью и возможностью подтвердить',
  'undefined': 'Без объявленной стоимости'
}
